import { connect, h, mapProps, mapReadPretty } from '@formily/vue'
import { defineComponent } from 'vue-demi'
import { SelectPreviewText } from '../PreviewText'
import Layout from './Layout.vue'

const RadioPickerBase = defineComponent({
  name: 'RadioGroup',
  props: {
    options: {
      type: Array,
      default: () => [],
    },
  },
  setup(props, { attrs, slots, listeners }) {
    return () => {
      const { options = [] } = props
      return h(
        Layout,
        {
          props: { options },
          attrs: {
            ...attrs,
          },
          on: listeners,
        },
        [],
      )
    }
  },
})

const RadioPicker = connect(
  RadioPickerBase,
  mapProps({ dataSource: 'options' }),
  mapReadPretty(SelectPreviewText),
)

export default RadioPicker
